import React from "react";
import { LegacyCard as Card, FormLayout, Select } from "@shopify/polaris";
import { TagMapTable } from "app/setup/modules/operator/features/productTagSetting/style";
import Table from "app/product/modules/generic/features/form/components/table";
import { baseHelper } from "lib/helpers";

const Location = (props) => {
  const {
    cms,
    currentUser,
    geoLocation,
    metaFieldData,
    setMetafielData,
    handleLocationChange,
    setDisabledButton,
    variantData,
    handleTableChange,
    handleDelete,
  } = props;
  const isSeller = baseHelper.isSeller(currentUser);
  return (
    <Card title="Location" id="variantLocation" sectioned>
      <FormLayout>
        {!isSeller && (
          <FormLayout.Group>
            <Select
              id="policySelection"
              options={geoLocation}
              placeholder="Select locations"
              onChange={(val) => {
                handleLocationChange(val);
                if (setDisabledButton) {
                  setDisabledButton(false);
                }
              }}
            />
          </FormLayout.Group>
        )}

        {!!(metaFieldData && metaFieldData.length) && (
          <TagMapTable className="tag-map-table">
            <Table
              cms={cms}
              currentUser={currentUser}
              data={metaFieldData}
              setData={setMetafielData}
              value={variantData}
              handleChange={handleTableChange}
              handleDelete={handleDelete}
            />
          </TagMapTable>
        )}
      </FormLayout>
    </Card>
  );
};

export default Location;
